import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import "../../../styles/forgetPassword.css";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
import { Input } from "@appkit4/react-components/field";
import displayToastMessage from "../Alert/displayToastMessage"
import emailIcon from "../../../assets/images/emailIcon.svg";
import pwcLogo from "../../../assets/images/tata_motors_logo.png";
import {Button} from "@appkit4/react-components/button"
import PropTypes from "prop-types";
import poweredByLogo from "../../../assets/images/poweredByLogo.png"

const ValidatedForgotpwdForm = (props) => {
const data=props.location.query;
  const [loading, setLoading] = useState(false)
  const { sendRequest: resetPassword } = useHttp();
  const handleLogin = () => {
    props.history.push("/login");
  };
  const responseHandler = (resetPwd) => {
    if (resetPwd.CODE) {
      setLoading(false)
      displayToastMessage(resetPwd.MSG, "success")
      setTimeout(() => {
        props.history.push("/login");
      }, 2000);
    } else {
      setLoading(false)
      displayToastMessage("Something went wrong!", "error")
    }
  }

  const handleForgotPassword = async (email) => {
    setLoading(true)
    try {
      email.email = email.email.trim()
      resetPassword(APIService.resetPassword(email),
      responseHandler, errorHandler)
    } catch (error) {
      console.log("Error",error)
      setLoading(false)
      displayToastMessage(error.response.data.MSG, "error")
    }
  }

  const errorHandler = (err) => {
    displayToastMessage(err.response.data.MSG, "error");
    setLoading(false);
  }
  return (
    <Formik
      initialValues={{ email: ""}}
      onSubmit={handleForgotPassword}
      validationSchema={Yup.object().shape({
        email: Yup.string().trim().email().required("Email Id is Required"),
      })}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
        } = props;

        return (
          <div className="loginBackground">
            <div className="container">
              <div className="row">
                <div className="row fixed-top login-bgm-alignment">
                  <div className="ps-4">
                    <img src={pwcLogo} alt="" height="80px"></img>
                  </div>
                  {/* <div className="vertical-line-header"></div>
                  <div className="pt-3">
                    <p className="header-text">TPRM</p>
                  </div> */}
                </div>
                <div className="col-lg-7 lf-div">
                  <h2 className="wt login-welcome">Welcome to the</h2>
                  <h3 className="login-tprm">Third Party Cybersecurity Assessment Programme</h3>
                  <p className="login-paragraph">
                  for Tata Motors Limited - A Web Based Assessment Questionnaire.
                  </p>
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-4 rgt-div   headerlogo loginBackgroundColor">
                  <div className="forgetPassword">
                    <div className="card-body ">
                      <div className="frgt-text ">{data}</div>
                      <div className="empty-div"></div>
                      <div className="">
                      </div>
                      <form onSubmit={handleSubmit} className="">
                        <div className="form-label-group userEmailField"  >
                          <Input
                            name="email"
                            type="text"
                            id="userfield-style-fpwd"
                            title="E-Mail"
                            value={values.email}
                            autoComplete="off"
                            onChange={handleChange("email")}
                            onBlur={handleBlur}
                            suffix={
                              <img
                                className="userIcon-style"
                                src={emailIcon}
                                alt="new"
                              />
                            }
                          />
                        </div>

                        {errors.email && touched.email && (
                          <div className="form-label errorMsg">
                            {errors.email}
                          </div>
                        )}
                        <div className="form-label-group userEmailField">
                        <div className="row t-2rem">
                                <div className="col-md-6">
                        <Button
                                    size="lg"
                            type="submit"
                            disabled={isSubmitting}
                            variant="primary"
                            className="forgetPasswordAlignment"
                          >
                            {loading && <div className="spinner-border spinner-border-sm" aria-hidden="true"></div>}&nbsp;
                            <span>Submit</span>&nbsp;&nbsp;
                            <span className="icon-arrow-right-fill"></span>
                          </Button>
                        </div>
                        <div className="col-md-6">

                        </div>
                        </div>
                        </div>
                        <div className="mt-3 clickHereLoginAlignment">
                         
                          <label className="login-font">Click here to</label>
                          <label className="forgotpwd-styles-fpwd" onClick={handleLogin}>
                            Login
                          </label>
                         
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              
              </div>
              <div className="row  m-t-20">
              <div className="col-lg-10">
                </div>
               <div className="col-lg-2 ">
               <img src={poweredByLogo} className="pwcPoweredByforgot" alt=""></img>
               </div>
              
             </div>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};
ValidatedForgotpwdForm.propTypes = {
  history: PropTypes.any,
  values: PropTypes.any,
  touched: PropTypes.any,
  errors: PropTypes.any,
  isSubmitting: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
}
export default ValidatedForgotpwdForm;
